(() => {
  'use strict';

  const SELECTOR = 'a[data-affiliate-store]';

  const articleHandle = () => {
    const match = location.pathname.match(/^\/blogs\/find-garden\/([^/?#]+)/);
    return match ? match[1] : '';
  };

  const linkDomain = (href) => {
    try {
      return new URL(href, location.href).hostname;
    } catch (_) {
      return '';
    }
  };

  document.addEventListener('click', (event) => {
    const link = event.target instanceof Element
      ? event.target.closest(SELECTOR)
      : null;
    if (!link) return;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      affiliate_store: link.dataset.affiliateStore || '',
      affiliate_placement: link.dataset.affiliatePlacement || '',
      affiliate_volume: link.dataset.affiliateVolume || '',
      affiliate_link_domain: linkDomain(link.href),
      article_handle: articleHandle(),
      page_path: location.pathname
    });
  }, { capture: true });
})();
